import { useEffect, useState } from "react";

export const TOTAL_SPOTS = 100;
const STARTING_SPOTS = 9;
const MIN_SPOTS = 3;
const STEP_MS = 75_000;
const START = Date.now();

function current(): number {
  const steps = Math.floor((Date.now() - START) / STEP_MS);
  return Math.max(MIN_SPOTS, STARTING_SPOTS - steps);
}

/** Promotional spots remaining — shared across every scarcity bar on the page. */
export function useSpotsLeft() {
  const [spots, setSpots] = useState(current);

  useEffect(() => {
    const id = window.setInterval(() => setSpots(current()), 5000);
    return () => window.clearInterval(id);
  }, []);

  return spots;
}
